<div class="key-info">
    <div class="main-info">
        <div class="area">eiendomer bygninger andeler</div>
        <div class="area full-height">Nokkelinfo</div>
    </div>

    <div class="secondary-info">
        <div class="area no-left-padding"><energy-label [energyRating]="energyRating"></energy-label></div>
        <div class="area"><scoring [scoringValues]="score"></scoring></div>

        @if (hasPhysicalExposuresRole() && physicalExposures()?.totalPhysicalRiskScore > 0) {
            <div class="area">
                <key-info-physical-exposure
                    [physicalExposures]="physicalExposures()"
                    (expandDetailsClicked)="goToPhysicalExposures()"
                ></key-info-physical-exposure>
            </div>
        }
        <div class="area">Spesielle forhold</div>
    </div>

    <div class="info-card image">
        <image-carousel [imagePackages]="imagePackages()" [estateType]="propertyImageClass"></image-carousel>
    </div>
    <div class="info-card tertiary-info">Areal</div>
    <!-- Todo: Sjekk om vi kan bytte ut link-taskbar med ev-link-taskbar og slette link-taskbar -->
    <div class="info-card link-taskbar"><link-taskbar [settings]="linkTaskbarSettings()"></link-taskbar></div>
</div>
